import { DescriptionStaff } from 'common/components/description';
import { ClampContainer, P1 } from 'common/components/Typography';
import { Epg } from 'common/constants/data-types';
import { getClassName } from 'common/utils';
import React, { useEffect, useState } from 'react';

const DELAY_EXPAND_SEASON_STRIPE = 1000;
interface VodSeasonStripeFooterProps {
  currentEpg?: Epg;
  pending?: boolean;
  visible?: boolean;
  hidden?: boolean;
}
function VodSeasonStripeFooter(props: VodSeasonStripeFooterProps) {
  const [visible, setVisible] = useState(props.visible);
  const [currentEpg, setCurrentEpg] = useState<Epg | undefined>();
  const timeoutRef = React.useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    if (props.visible) {
      timeoutRef.current = setTimeout(() => {
        setVisible(true);
      }, DELAY_EXPAND_SEASON_STRIPE);
      setCurrentEpg(props.currentEpg);
    } else if (props.hidden) {
      setVisible(false);
      setCurrentEpg(undefined);
    }

    return () => clearTimeout(timeoutRef.current);
  }, [props.visible, props.hidden, props.currentEpg]);

  return (
    <div
      className={getClassName('vod-season-stripe-footer', {
        visible: visible,
        pending: props.pending
      })}
    >
      <ClampContainer lines={3}>
        <P1 data-test-id="vod-season-stripe-footer-description">
          {currentEpg?.shorttext || currentEpg?.fulltext || currentEpg?.subtitle}
        </P1>
      </ClampContainer>
      <DescriptionStaff actors={currentEpg?.actors} persons={currentEpg?.persons} />
    </div>
  );
}

export default React.memo(VodSeasonStripeFooter);
